import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clearSession, getSession, setSession } from '../utils/session';

export interface NotificationStateInterface {
	isVisible?: false;
	type: string;
	heading: string;
	body: string;
}

export interface CommonStateInterface {
	notification: NotificationStateInterface;
	notificationError: NotificationStateInterface;
	isDevicePinExpired: boolean;
	isPinAutoSubmitted: false;
	isAppleEventListened: false;
}

const notificationInitialState: NotificationStateInterface = {
	isVisible: false,
	type: 'ERROR',
	heading: '',
	body: ''
};

const notificationInitialStateError: NotificationStateInterface = {
	isVisible: false,
	type: 'ERROR',
	heading: '',
	body: ''
};

const commonInitialState: CommonStateInterface = {
	notification: notificationInitialState,
	notificationError: notificationInitialStateError,
	isDevicePinExpired: getSession('isDevicePinExpired') ? true : false,
	isPinAutoSubmitted: false,
	isAppleEventListened: false
};

export const commonSlice = createSlice({
	name: 'common',
	initialState: commonInitialState,
	reducers: {
		openNotification: (state: any, action: PayloadAction<NotificationStateInterface>) => {
			state.notification = {
				isVisible: true,
				type: action.payload.type,
				heading: action.payload.heading,
				body: action.payload.body
			};
		},
		openNotificationError: (state: any, action: PayloadAction<NotificationStateInterface>) => {
			state.notificationError = {
				isVisible: true,
				type: action.payload.type,
				heading: action.payload.heading,
				body: action.payload.body
			};
		},
		closeNotification: (state: any) => {
			state.notification = notificationInitialState;
			state.notificationError = notificationInitialStateError;
		},
		setDevicePinExpiredStatus: (state: any, action: any) => {
			if (action.payload) {
				setSession('isDevicePinExpired', true);
			} else {
				clearSession('isDevicePinExpired');
			}

			state.isDevicePinExpired = action.payload;
		},
		setPinAutoSubmitStatus: (state, action) => {
			state.isPinAutoSubmitted = action.payload;
		}
	}
});

export const {
	openNotification,
	openNotificationError,
	closeNotification,
	setDevicePinExpiredStatus,
	setPinAutoSubmitStatus
} = commonSlice.actions;

export default commonSlice.reducer;
